import React, { useRef } from 'react';

import logo from '../../assets/logo.svg';
import { FiMenu } from 'react-icons/fi';

const activeClass = 'after:w-1/2 after:mx-auto after:block after:relative after:top-1 after:rounded-full after:border-b-4 after:border-main';

const Navbar = ({ navbarTransparent, currentMenu, setCurrentMenu, sectionRefs }) => {
  const menuMobileRef = useRef();

  const toggleMobileMenu = () => {
    menuMobileRef.current.classList.toggle('-translate-x-full');
  }

  const goHome = () => {
    sectionRefs[0].current.scrollIntoView({ behavior: 'smooth' });
  }

  const goService = () => {
    sectionRefs[1].current.scrollIntoView({ behavior: 'smooth' });
  }

  const goProject = () => {
    sectionRefs[2].current.scrollIntoView({ behavior: 'smooth' });
  }

  const goContact = () => {
    sectionRefs[3].current.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <>
      <nav className={`fixed top-0 w-full h-16 py-2 px-3 transition-colors duration-1000 ${navbarTransparent ? 'bg-white md:bg-white/80' : 'bg-white'} flex justify-between items-center z-20 md:px-6 2xl:px-16`}>
        <button className="md:hidden" onClick={toggleMobileMenu}>
          <FiMenu size={32} className="text-slate-700" />
        </button>
        <div className="flex justify-center grow md:hidden">
          <img src={logo} alt="Logo" className="h-8" />
        </div>
        <div className="invisible w-8 md:visible md:grow md:w-full">
          <button className="tracking-widest font-semibold text-base text-slate-700">
            COTECHCA
          </button>
        </div>
        <ul className="hidden md:space-x-6 md:flex lg:space-x-10">
          <li>
            <button
              className={`text-base font-semibold ${currentMenu === 0 ? 'text-main' : 'text-slate-700'} uppercase tracking-widest hover:text-main ${currentMenu === 0 && activeClass} `}
              onClick={goHome}
            >Home</button>
          </li>
          <li>
            <button
              className={`text-base font-semibold ${currentMenu === 1 ? 'text-main' : 'text-slate-700'} uppercase tracking-widest hover:text-main ${currentMenu === 1 && activeClass} `}
              onClick={goService}
            >Service</button>
          </li>
          <li>
            <button
              className={`text-base font-semibold ${currentMenu === 2 ? 'text-main' : 'text-slate-700'} uppercase tracking-widest hover:text-main ${currentMenu === 2 && activeClass} `}
              onClick={goProject}
            >Project</button>
          </li>
        </ul>
        <div className="hidden md:flex md:justify-end md:grow md:w-full">
          <button
            className="uppercase bg-main py-2 px-4 rounded-md text-base font-semibold text-white tracking-widest"
            onClick={goContact}
          >
            Contact Us
          </button>
        </div>
      </nav>
      <div className={`w-full bg-transparent fixed top-16 z-30 -translate-x-full transition-transform duration-500`} ref={menuMobileRef}>
        <ul className="w-full bg-white/70 px-5 py-5 space-y-4">
          <li><button className={`uppercase tracking-wider font-medium ${currentMenu === 0 ? 'text-main' : 'text-slate-700'}`} onClick={() => {
            goHome();
            toggleMobileMenu();
          }}>Home</button></li>
          <li><button className={`uppercase tracking-wider font-medium ${currentMenu === 1 ? 'text-main' : 'text-slate-700'}`} onClick={() => {
            goService();
            toggleMobileMenu();
          }} >Service</button></li>
          <li><button className={`uppercase tracking-wider font-medium ${currentMenu === 2 ? 'text-main' : 'text-slate-700'}`} onClick={() => {
            goProject();
            toggleMobileMenu();
          }} >Project</button></li>
          <li><button className="bg-sky-500 px-4 py-2 rounded-md text-white uppercase tracking-wider font-medium" onClick={() => {
            goContact();
            toggleMobileMenu();
          }}>Contact</button></li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
